// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uqGg-","footer":"styles_footer__1bGfT"};